export default "__VITE_ASSET__0c5c57b7__"